import axios from "axios";
import { config } from "../config/config";
import { Common } from "../../common/src";
import { TProjectionMode } from "../viewer/utils/camera-utils";

export const fetchUserInfo = () => {
  return new Promise<Common.LandlogNecessaryUserInfo>(
    async (resolve, reject) => {
      try {
        const url = `${config.serverHost}/api/v1/user`;
        const res = await axios.get(url, { withCredentials: true });
        resolve(res.data);
      } catch (e) {
        reject(e);
      }
    },
  );
};

export const fetchUserLicense = () => {
  return new Promise<Common.LandlogLicenseStatus>(async (resolve, reject) => {
    try {
      const url = `${config.serverHost}/api/v1/user/licenses`;
      const res = await axios.get(url, { withCredentials: true });
      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
};

export const updateProjectionModeUserSetting = async (
  payload: any,
): Promise<Common.LandlogLicenseStatus> => {
  try {
    const url = `${config.serverHost}/api/v1/user/setting`;
    const res = await axios.put(url, payload, { withCredentials: true });
    return res.data;
  } catch (e) {
    throw e;
  }
};

// SC_QUICK-2183 — project list page: sort order & display mode, saved per user
export const updateProjectListSetting = async (
  payload: Partial<
    Pick<Common.userSetting, "projectListSortBy" | "projectListViewType">
  >
): Promise<void> => {
  const url = `${config.serverHost}/api/v1/user/setting`;
  await axios.put(url, payload, { withCredentials: true });
};


export const userSettingAPIs = {
  get: (): Promise<Common.userSetting> => {
    return new Promise<Common.userSetting>(async (resolve, reject) => {
      try {
        const url = `${config.serverHost}/api/v1/user/setting`;
        const res = await axios.get(url, { withCredentials: true });
        resolve(res.data);
      } catch (e) {
        reject(e);
      }
    });
  },

  updateColumnSetting: async (
    payload: Partial<Common.userSetting>,
  ): Promise<void> => {
    const url = `${config.serverHost}/api/v1/user/setting`;
    await axios.put(url, payload, { withCredentials: true });
  },
};
